<app-navbar></app-navbar>

<div class="page-container">
  <div class="banner"></div>
  
  <div class="content-container">
   <app-detail (hostingSelected)="onHostingSelectedFromDetail($event)"></app-detail>

    <div class="page-header">

      <h1 class="page-title">Recepción de Huéspedes</h1>
      <div>
        
      </div>
      <div class="step-indicator">
        <span class="step active">1</span>
        <span class="step-text">Buscar Reserva</span>
      </div>
    </div>

    <div class="form-section">
      <!-- Formulario para buscar reserva por número -->
      <form (ngSubmit)="searchReservations()">
        <label for="reservationId">Número de reserva:</label>
        <input id="reservationId" [(ngModel)]="reservationId" name="reservationId" required />
        <button type="submit" [disabled]="reservationId === ''" ngClass="btn btn-primary">Buscar reserva</button>
      </form>

      <!-- Mensaje de carga y error -->
      <div *ngIf="loading" class="loading">Buscando reserva...</div>
      <div *ngIf="error" class="error">{{ error }}</div>
    </div>

    <!-- Mostrar datos de la reserva si existen -->
    <div *ngIf="reservationData?.reservation" class="reservation-data-section">
      <h3>Datos de la reserva</h3>
      <div class="reservation-card">
        <div *ngIf="!documentData" class="DatosImagenes">
          <strong>Foto de Documento de Identidad:</strong>

          <!-- Área de subida de archivos -->
          <div *ngIf="!documentData" class="upload-area" [class.dragover]="isDragOver" (dragover)="onDragOver($event)"
              (dragleave)="onDragLeave($event)" (drop)="onFilesDrop($event)">

              <div class="upload-content">
                  <div class="upload-icon">📸</div>
                  <p class="upload-text">
                      Arrastrar archivo o
                      <label for="file-input" class="upload-link">Seleccionar archivo</label>
                  </p>
                  <input type="file" id="file-input" accept="image/*,application/pdf" (change)="onFilesSelected($event)"
                      style="display: none;">
                  <p class="upload-info">
                      Formatos permitidos: JPG, PNG, WebP, PDF • Tamaño máximo: 5MB
                  </p>
              </div>            
          </div> 
        </div>
        <div *ngIf="documentData">
          <p><strong>Foto de Documento de Identidad</strong>: <a [href]="documentData?.url" target="_blank">Ver imagen</a></p>
        </div>  
        <div>
          <strong>Número de reserva:</strong> {{ reservationData.reservation.reservationId }}
        </div>         
        <div>
          <strong>Hotel:</strong> {{ reservationData.reservation.hotel_name || reservationData.reservation.hotelId }}
        </div>
        <div>
          <strong>Habitación:</strong> {{ reservationData.reservation.room_name || reservationData.reservation.roomId }}
        </div>
        <div>
          <strong>Check-in:</strong> {{ reservationData.reservation.checkInDate | date:'mediumDate' }}
        </div>
        <div>
          <strong>Check-out:</strong> {{ reservationData.reservation.checkOutDate | date:'mediumDate' }}
        </div>
        <div>
          <strong>Valor básico:</strong> ${{ reservationData.reservation.basic_value }}
        </div>
        <div>
          <strong>Impuestos:</strong> ${{ reservationData.reservation.taxes_value }}
        </div>
        <div>
          <strong>Total:</strong> ${{ reservationData.reservation.total_value }}
        </div>


            

        <!-- Previsualización de la imagen subida 
        <div class="image-preview" *ngIf="documentImagePreview">
            <h3>Previsualización:</h3>
            <img [src]="documentImagePreview" alt="Previsualización de la imagen" />
            <p *ngIf="documentImage">Imagen subida con éxito: <a [href]="documentImage" target="_blank">Ver imagen</a></p>
        </div>
        -->

        <div>
          <strong>Estado de pago:</strong>
          <span [ngClass]="reservationData.reservation.payment_status === 'Pagado' ? 'paid' : 'not-paid'">
            {{ reservationData.reservation.payment_status }}
          </span>
        </div>        
        <div *ngIf="reservationData.reservation.payment_status !== 'Pagado'" class="confirm-payment-section" style="margin-top: 1.5rem;">
          <h4>Confirmación de pago</h4>
          <div class="payment-methods">
            <label>
              <input
                type="radio"
                name="paymentMethod"
                value="billetera digital"
                [(ngModel)]="selectedPaymentMethod"
                [disabled]="reservationData.reservation.payment_status === 'Pagado'"
              />
              Billetera Digital
            </label>
            <label>
              <input
                type="radio"
                name="paymentMethod"
                value="efectivo"
                [(ngModel)]="selectedPaymentMethod"
                [disabled]="reservationData.reservation.payment_status === 'Pagado'"
              />
              Efectivo
            </label>            
          </div>
          <div class="selected-method" *ngIf="selectedPaymentMethod">
            <small>Método seleccionado: <strong>{{ selectedPaymentMethod | titlecase }}</strong></small>
          </div>
          <button
            type="button"
            class="btn btn-primary"
            style="margin-top: 0.5rem;"
            [disabled]="!selectedPaymentMethod"
            (click)="confirmarPago(selectedPaymentMethod)"
          >
            Confirmar pago
          </button>          
        </div>
        <div>
          <strong>Estadía:</strong> {{ reservationData.reservation.status }}
        </div>
        <div *ngIf="reservationData.reservation.payment_status === 'Pagado' && documentData && reservationData.reservation.status !== 'Iniciada' && reservationData.reservation.status !== 'Finalizada'">
          <button type="button" class="btn btn-success" (click)="iniciarEstadia()">
            Iniciar estadía
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>